import _ from 'lodash';

export const computePricing = (msrp, incentives) => {
  const getLuxuryTaxVal = (netPrice) =>
    msrp.flt && msrp.flt.above < netPrice
      ? (netPrice - msrp.flt.above) * msrp.flt.taxRate
      : 0;

  const totalMsrp = msrp.employeePrice ? msrp.employeePrice : msrp.totalMsrp;
  const eventDiscount = msrp.isConfidencePrice
    ? totalMsrp - msrp.supplierPrice
    : 0;

  const incentiveDiscount = msrp.totalIncludedIncentivesValue
    ? msrp.totalIncludedIncentivesValue
    : 0;
  const totalDiscountWithoutPacakge = incentiveDiscount + eventDiscount;

  const employeePriceDifference = msrp.employeePrice
    ? msrp.totalMsrp - msrp.employeePrice
    : 0;
  const totalDiscount =
    totalDiscountWithoutPacakge + (msrp.opdTotal ? msrp.opdTotalValue : 0); //$-1000
  const totalEmployeeDiscount = employeePriceDifference
    ? totalDiscount + employeePriceDifference
    : 0;
  const netEmployeePrice = totalMsrp - totalDiscountWithoutPacakge; // netPrice in 2.0
  const netPrice = msrp.totalMsrp - totalDiscountWithoutPacakge;

  const luxuryTaxNetPrice = netPrice + getLuxuryTaxVal(netPrice);

  const luxuryTaxNetEmployeePrice =
    netEmployeePrice + getLuxuryTaxVal(netEmployeePrice);

  return _.assign({}, msrp, {
    incentives: incentives,
    eventDiscount: eventDiscount,
    totalDiscount: totalDiscount,
    netEmployeePrice: luxuryTaxNetEmployeePrice,
    employeePriceDifference: employeePriceDifference,
    totalEmployeeDiscount: totalEmployeeDiscount,
    isSeeDealer: !msrp.isActualPrice,
    netPrice: luxuryTaxNetPrice,
  });
};
